import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="1px 1px 3px rgba(0,0,0,.6)"
          column
          alignCenter
        >
          <Header />
          <CFView textCenter w="100%">
            <CFView mt="100px">
              <CFImage
                w="85%"
                src={mobileHeroText}
                alt="Ra Sushi hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mv="35px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="700px"
          w="100%"
          image={`url(${hero}) left/ cover no-repeat`}
          zIndex={90}
          column
          justifyStart
        >
          <Header />
          <CFView column justifyCenter alignStart ml="70px" mt="180px">
            <CFView column justifyCenter alignStart>
              <CFImage
                h="120px"
                src={heroText}
                alt="Ra Sushi hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mv="60px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
